/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Not_Enough_Coins_DescriptionInputs */

const en_dialog_not_enough_coins_description = /** @type {(inputs: Dialog_Not_Enough_Coins_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep focusing to earn more, or get more at the Shop.`)
};

const ar_dialog_not_enough_coins_description = /** @type {(inputs: Dialog_Not_Enough_Coins_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استمر في التركيز لكسب المزيد، أو احصل على المزيد من المتجر.`)
};

const de_dialog_not_enough_coins_description = /** @type {(inputs: Dialog_Not_Enough_Coins_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokussiere weiter, um mehr zu verdienen, oder hol dir mehr im Shop.`)
};

const es_dialog_not_enough_coins_description = /** @type {(inputs: Dialog_Not_Enough_Coins_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sigue concentrándote para ganar más, o consigue más en la Tienda.`)
};

const fr_dialog_not_enough_coins_description = /** @type {(inputs: Dialog_Not_Enough_Coins_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue à te concentrer pour en gagner plus, ou obtiens-en plus dans la boutique.`)
};

const it_dialog_not_enough_coins_description = /** @type {(inputs: Dialog_Not_Enough_Coins_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua a concentrarti per guadagnare di più, o ottienine di più nel Negozio.`)
};

const ja_dialog_not_enough_coins_description = /** @type {(inputs: Dialog_Not_Enough_Coins_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中を続けてもっと獲得するか、ストアで手に入れましょう。`)
};

const ko_dialog_not_enough_coins_description = /** @type {(inputs: Dialog_Not_Enough_Coins_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계속 집중해서 더 모으거나, 상점에서 채우세요.`)
};

const pt_br_dialog_not_enough_coins_description = /** @type {(inputs: Dialog_Not_Enough_Coins_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue focando para ganhar mais, ou consiga mais na Loja.`)
};

const ru_dialog_not_enough_coins_description = /** @type {(inputs: Dialog_Not_Enough_Coins_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжай фокусироваться, чтобы заработать больше, или получи ещё в магазине.`)
};

const th_dialog_not_enough_coins_description = /** @type {(inputs: Dialog_Not_Enough_Coins_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โฟกัสต่อไปเพื่อสะสมเพิ่ม หรือไปรับเพิ่มที่ร้านค้า`)
};

const tr_dialog_not_enough_coins_description = /** @type {(inputs: Dialog_Not_Enough_Coins_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha fazlası için odaklanmaya devam et ya da Mağazadan daha fazlasını al.`)
};

const zh_cn_dialog_not_enough_coins_description = /** @type {(inputs: Dialog_Not_Enough_Coins_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续专注就能赚取更多，或到商店补充。`)
};

const zh_tw_dialog_not_enough_coins_description = /** @type {(inputs: Dialog_Not_Enough_Coins_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繼續專注就能賺取更多，或到商店補充。`)
};

/**
* | output |
* | --- |
* | "Keep focusing to earn more, or get more at the Shop." |
*
* @param {Dialog_Not_Enough_Coins_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_not_enough_coins_description = /** @type {((inputs?: Dialog_Not_Enough_Coins_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Not_Enough_Coins_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_not_enough_coins_description(inputs)
	if (locale === "ar") return ar_dialog_not_enough_coins_description(inputs)
	if (locale === "de") return de_dialog_not_enough_coins_description(inputs)
	if (locale === "es") return es_dialog_not_enough_coins_description(inputs)
	if (locale === "fr") return fr_dialog_not_enough_coins_description(inputs)
	if (locale === "it") return it_dialog_not_enough_coins_description(inputs)
	if (locale === "ja") return ja_dialog_not_enough_coins_description(inputs)
	if (locale === "ko") return ko_dialog_not_enough_coins_description(inputs)
	if (locale === "pt_br") return pt_br_dialog_not_enough_coins_description(inputs)
	if (locale === "ru") return ru_dialog_not_enough_coins_description(inputs)
	if (locale === "th") return th_dialog_not_enough_coins_description(inputs)
	if (locale === "tr") return tr_dialog_not_enough_coins_description(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_not_enough_coins_description(inputs)
	return zh_tw_dialog_not_enough_coins_description(inputs)
});